module.exports = __webpack_public_path__ + "img/double-ringed-orb.17c26031.svg";